import { steps } from '../internal';
export var stepStart = steps(1, 1);
